<template>
  <Dialog :title="$t('Tarifas')" v-model="show">
    <!-- Formulario -->
    <template v-slot:content>
      <v-form ref="form" lazy-validation class="pa-1">
        <!-- Mensaje informativo -->
        <div class="container_info_azul">
          <span>{{
              $t("Especifica qué tarifa se aplica a cada día de la semana, escogiendose los precios de los servicios en función de la tarifa seleccionada.")
            }}</span>
        </div>

        <!-- LUNES FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Lunes')"
                outlined
                dense
                v-model="tarifas.monday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN LUNES FIELD -->

        <!-- MARTES FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Martes')"
                outlined
                dense
                v-model="tarifas.tuesday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN MARTES FIELD -->

        <!-- MIERCOLES FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Miércoles')"
                outlined
                dense
                v-model="tarifas.wednesday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN MIERCOLES FIELD -->

        <!-- JUEVES FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Jueves')"
                outlined
                dense
                v-model="tarifas.thursday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN JUEVES FIELD -->

        <!-- VIERNES FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Viernes')"
                outlined
                dense
                v-model="tarifas.friday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN VIERNES FIELD -->

        <!-- SABADO FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Sábado')"
                outlined
                dense
                v-model="tarifas.saturday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN SABADO FIELD -->

        <!-- DOMINGO FIELD -->
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-select
                hide-details
                :label="$t('Domingo')"
                outlined
                dense
                v-model="tarifas.sunday"
                :items="data_form.tarifa"
            ></v-select>
          </v-col>
        </v-row>
        <!-- FIN DOMINGO FIELD -->
      </v-form>
    </template>

    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary ml-2">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'FormTarifas',
  props: ['value'],
  data: () => ({
    // Tarifas
    tarifas: {
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0
    },
    data_form: {
      tarifa: []
    },
  }),

  methods: {

    /**
     * Recuperar los datos necesarios para pintar el formulario
     * @returns {Promise<void>}
     */
    async get_data_form() {
      this.data_form.tarifa = [
        {value: 0, text: this.$t('Por defecto')},
        {value: 1, text: `${this.$t('Tarifa')} 1`},
        {value: 2, text: `${this.$t('Tarifa')} 2`},
        {value: 3, text: `${this.$t('Tarifa')} 3`},
        {value: 4, text: `${this.$t('Tarifa')} 4`},
      ]
    },

    async save() {
      try {
        await this.$store.dispatch('centro/save', {tarifas: this.tarifas})
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.show = false
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },


    /**
     * Recupera las tarifas del centro de la api
     * @returns {Promise<void>}
     */
    async get_tarifas() {
      try {
        const centro = await this.$store.dispatch('centro/get_centro')
        const tarifas = centro.tarifas

        if(tarifas){
          if (tarifas.monday)
            this.tarifas.monday = tarifas.monday
          if (tarifas.tuesday)
            this.tarifas.tuesday = tarifas.tuesday
          if (tarifas.wednesday)
            this.tarifas.wednesday = tarifas.wednesday
          if (tarifas.thursday)
            this.tarifas.thursday = tarifas.thursday
          if (tarifas.friday)
            this.tarifas.friday = tarifas.friday
          if (tarifas.saturday)
            this.tarifas.saturday = tarifas.saturday
          if (tarifas.sunday)
            this.tarifas.sunday = tarifas.sunday
        }

      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  mounted() {
    this.get_data_form()
    this.get_tarifas()
  },
}
</script>
